$(window).on('scroll', function () {
  const $container = $('.wp-block-acf-scroll-text');
  const $parent = $container.closest('.scroll-text');

  if (!$container.length || !$parent.length) return;

  const scrollTop = $(window).scrollTop();
  const windowHeight = $(window).height();

  const parentTop = $parent.offset().top;
  const parentHeight = $parent.outerHeight();

  // START point: When the top 10% mark of the parent container passes the middle of the viewport
  const startScroll = parentTop + (parentHeight * 0.30) - (windowHeight / 2);

  // END point: Exactly before the last 10% (the 90% mark) of the parent container
  const endScroll = parentTop + (parentHeight * 0.70) - (windowHeight / 2);

  // Safety check in case calculations overlap
  if (endScroll <= startScroll) return;

  // Calculate overall scroll progress (0 to 1) between the 10% and 90% parent markers
  let scrollPercent = (scrollTop - startScroll) / (endScroll - startScroll);
  scrollPercent = Math.max(0, Math.min(1, scrollPercent));

  // --- Container Transform Logic ---
  const currentY = 28 - (28 * scrollPercent);
  $container.css('transform', `translateY(${currentY}px)`);

  // --- Children Opacity Logic ---
  const $elements = $container.find('.wp-block-acf-scroll-text__qw, .wp-block-acf-scroll-text__quote-face, .wp-block-acf-scroll-text__quote-cite');
  const totalElements = $elements.length;

  $elements.each(function (index) {
    const elementStartPercent = index / totalElements;
    const elementEndPercent = (index + 1) / totalElements;

    if (scrollPercent >= elementEndPercent) {
      $(this).css('opacity', 1);
    } else if (scrollPercent <= elementStartPercent) {
      $(this).css('opacity', 0.16);
    } else {
      const elementPercent = (scrollPercent - elementStartPercent) / (elementEndPercent - elementStartPercent);
      const targetOpacity = 0.16 + (0.84 * elementPercent);
      $(this).css('opacity', targetOpacity);
    }
  });
});
